import { InjectionToken } from '@angular/core';

export const ELM_COMPONENTS_THEME_STYLES = new InjectionToken<string>(
  'Element451 Components Theme Styles'
);

export const ELM_MATERIAL_THEME_STYLES = new InjectionToken<string>(
  'Element451 Material Components Theme Styles'
);
